import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient, HttpEvent, HttpEventType, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';

//Services
import { PortalSettingsService } from 'src/app/core/services/portal-settings.service';
import { SignalRService } from 'src/app/core/services/signal-r.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { HiringService } from '../../hiring/services/hiring.service';
import { EventService } from 'src/app/core/services/event.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { EmployeeService } from '../../employee/services/employee.service';
import { TimeoutService } from 'src/app/core/services/timeout.service';

//Components
import { WarningModalComponent } from 'src/app/modals/shared/warning-modal/warning-modal.component';
import { OnboardSubmittedModalComponent } from 'src/app/modals/careers/onboard-submitted-modal/onboard-submitted-modal.component';
import { EditPersonalModalComponent } from 'src/app/modals/careers/edit-personal-modal/edit-personal-modal.component';

import {
  PdfViewerComponent, LinkAnnotationService, BookmarkViewService, MagnificationService,
  ThumbnailViewService, ToolbarService, NavigationService, SignatureFieldSettings,
  AnnotationService, TextSearchService, TextSelectionService,
  PrintService, FormDesignerService, FormFieldsService, ValidateFormFieldsArgs
} from '@syncfusion/ej2-angular-pdfviewer';

@Component({
  selector: 'app-tasks',
  templateUrl: './tasks.component.html',
  styleUrls: ['./tasks.component.css'],
  providers: [LinkAnnotationService, BookmarkViewService, MagnificationService,
    ThumbnailViewService, ToolbarService, NavigationService, SignatureFieldSettings,
    AnnotationService, TextSearchService, TextSelectionService,
    PrintService, FormDesignerService, FormFieldsService]
})
export class TasksComponent implements OnInit {
  public pdfviewerControl: PdfViewerComponent;
  formData: { [key: string]: any } = {};
  portalSettings: any;
  mobileMode: boolean = false;
  oNtaskText: string;
  oNtaskCompletedText: string;
  aTStaskText: string;
  aTStaskCompletedText: string;
  maxAttachments: number;
  customSubmitText: string;
  taskCount: number = 0;
  completedCount: number = 0;
  incompleteCount: number = 0;
  finishLoading: boolean = false;
  viewPDF: boolean = false;
  personalInfoRequire: { [key: string]: any } = {};
  reqID: any;
  jobDetails: any;
  loginStatus: boolean = false;
  infoData: any;
  coreList: any[] = [];
  isPersonalInfoCompleted: boolean = false;
  includeW4: boolean = false;
  includeI9: boolean = false;
  alreadySubmitted: boolean = false;
  includeDirectDeposit: number;
  includeEmergencyContacts: boolean = false;
  includeIdentification: boolean = false;
  tasks: any[] = [];
  questionList: any[] = [];
  savedFiles: any[] = [];
  showAttachmentWarning: boolean = false;
  attachmentWidth: number;
  newFiles: any[] = [];
  fileData: any[] = [];
  innerCounter: number;
  lastSave: { [key: string]: any } = {};
  errorMsg: any;
  service: any;
  printMode: string = "NewWindow";
  pdfResource: any;
  constructor(portalSettingsService: PortalSettingsService, private signalRService: SignalRService, private utilityService: UtilityService, private hiringService: HiringService, private eventService: EventService, private sharedModalService: BsModalService, private modalService: NgbModal, private employeeService: EmployeeService, public HttpClient: HttpClient, private timeoutService: TimeoutService, private router: Router) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.signalRService.establishHub('progressHub', 'downloadComplete');
    this.mobileMode = utilityService.isMobileMode();
  }

  ngOnInit(): void {
    this.service = "/Api/PdfViewer";
    this.pdfResource = window.location.origin + "/dist/assets/ej2-pdfviewer-lib";
    this.oNtaskText = this.portalSettings.ONTaskText.ConfigValue;
    this.oNtaskCompletedText = this.portalSettings.ONTaskCompletedText.ConfigValue;
    this.aTStaskText = this.portalSettings.ATSTaskText.ConfigValue;
    this.aTStaskCompletedText = this.portalSettings.ATSTaskCompletedText.ConfigValue;
    this.maxAttachments = this.portalSettings.MaxNumberOfAttachments.ConfigValue;
    this.customSubmitText = this.portalSettings.CustomSubmitText.ConfigValue;
    this.timeoutService.initializeTimeoutConfig();

    this.signalRService.downloadCompletedEvent.subscribe((filename: any) => {
      this.utilityService.closeModal();
    });

    this.personalInfoRequire = { FirstName: false, LastName: false, Email: false, Cell: false, Phone: false, Contact: false, Address1: false, Address2: false, City: false, State: false, Zip: false, Country: false, MidName: false, Suffix: false, MaritalStatus: false };

    this.attachmentWidth = document.getElementById("screenWidth").clientWidth - 100;
    if (this.attachmentWidth > 500)
      this.attachmentWidth = 500;
    if (this.attachmentWidth >= (document.getElementById("screenWidth").clientWidth) / 2)
      this.attachmentWidth = (document.getElementById("screenWidth").clientWidth) / 2 - 100;
    if (this.attachmentWidth < 250)
      this.attachmentWidth = 250;

    this.getInfo();
    this.getAttachmentList();
  }

  ngOnDestroy(): void {
    // Stop SignalR connection to prevent multiple connections
    this.signalRService.stopConnection();
  }

  getJobDetail() {
    this.hiringService.getReqDetails(this.reqID).then((response: any[]) => {
      if (response != null) {
        this.jobDetails = response;
      }
    });
  }

  getLoginStatus() {
    this.hiringService.getLoginStatus().subscribe((response: any) => {
      if (response != null) {
        this.loginStatus = response == "True";
        if (this.infoData != null)
          this.infoData.LoggedIn = this.loginStatus;
      }
    });
  }

  getInfo() {
    this.hiringService.getInfoByOnboardID().then((response: any) => {
      if (response != null) {
        this.coreList = [];
        this.infoData = response;
        this.getLoginStatus();

        this.isPersonalInfoCompleted = this.infoData.PersonalInfoCompleteCheck;

        if (response.IncludeW4 && response.IsOnboarding) {
          this.coreList.push({ Url: "/careers/fillw4", OnboardTaskName: "W-4 Employee's Withholding Allowance Certificate", OnboardTaskDateCompleted: response.IsW4Complete });
          if (!response.IsW4Complete)
            this.incompleteCount++;
        }
        if (response.IncludeI9 && response.IsOnboarding) {
          if (!response.IsI9Complete)
            this.incompleteCount++;
          this.coreList.push({ Url: "/careers/filli9", OnboardTaskName: "I-9 Employment Eligibility Verification", OnboardTaskDateCompleted: response.IsI9Complete });
        }
        if (response.IncludeIdentification) {
          var IsIdenComplete = ((response.Disability != null && response.Gender != null && response.RaceEthnic != null && response.Veteran != null) ? true : false);
          this.coreList.push({ Url: "/careers/identification", OnboardTaskName: "Voluntary Self-Identification", OnboardTaskDateCompleted: IsIdenComplete });
          if (!IsIdenComplete)
            this.incompleteCount++;
        }
        if (response.IncludeDirectDeposit != 0) {
          var IsDDComplete = response.IsDDComplete;
          this.coreList.push({ Url: "/careers/directdeposit", OnboardTaskName: "Direct Deposit", OnboardTaskDateCompleted: IsDDComplete });
          if (!IsDDComplete && response.IncludeDirectDeposit == 1)
            this.incompleteCount++;
        }
        if (response.IncludeEmergencyContacts) {
          var IsECComplete = response.IsECComplete;
          this.coreList.push({ Url: "/careers/emergencycontacts", OnboardTaskName: "Emergency Contacts", OnboardTaskDateCompleted: IsECComplete });
          if (!IsECComplete)
            this.incompleteCount++;
        }
        if (response.ReqID != null) {
          this.reqID = response.ReqID;
          this.getJobDetail();
        }
        this.includeW4 = response.IncludeW4;
        this.includeI9 = response.IncludeI9;
        if (response.DateSubmitted != null)
          this.alreadySubmitted = true;
        else
          this.alreadySubmitted = false;
        this.getTasks();
        if (this.reqID != null)
          this.getQuestion();
        this.includeDirectDeposit = response.IncludeDirectDeposit;
        this.includeEmergencyContacts = response.IncludeEmergencyContacts;
        this.includeIdentification = response.IncludeIdentification;
        this.finishLoading = true;
        if (!this.infoData.IsOnboarding)
          this.eventService.broadcast('ISAT');
        else
          this.eventService.broadcast('ISON');
      }
    });
  }

  getTasks() {
    this.hiringService.getTasksByOnboardID().then((response: any[]) => {
      if (response != null) {
        var processes = response;
        this.taskCount = processes.length;
        for (var i = 0; i < processes.length; i++) {
          if (processes[i].OnboardChecklistInstanceID != null) {
            processes[i].Url = "/careers/onboardingform/" + processes[i].OnboardChecklistInstanceID;
          }
          else if (processes[i].OnboardBulletinID != null) {
            processes[i].Url = "/careers/onboardingdocument/" + processes[i].OnboardBulletinID;
          }
          if (processes[i].OnboardTaskDateCompleted != null)
            this.completedCount++;
          else if (processes[i].OnboardTaskIsRequired)
            this.incompleteCount++;
        }
        this.tasks = processes;
      }
    });
  }

  getQuestion() {
    this.hiringService.reqSpecQuesAnswerGet(this.reqID).then((response: any[]) => {
      if (response != null) {
        this.questionList = response;
      }
    });
  }

  saveAnswer(data: any) {
    this.hiringService.reqSpecQuesAnswerAddEdit(data.ReqSpecAnswerID == null ? -1 : data.ReqSpecAnswerID, data.ReqSpecQuesID, data.QuestionText, data.AnswerText).then((response: any) => {
      if (response != null) {
        this.fadeLabel(response.success);
      }
    });
  }

  cancelTask() {
    const initialState = {
      modalData: { modalTitle: "Cancel the Application", modalMessage: "Are you sure you want to cancel your application?" + "</br>All data will be lost.", modalAction: "Cancel This Application", closeButtonText: "Return", warningLevel: "danger" },
      backdrop: 'static',
      size: 'md'
    };

    let modalRef = this.sharedModalService.show(WarningModalComponent, { initialState, ignoreBackdropClick: true, keyboard: true });
    modalRef.onHide.subscribe((reason: any) => {
      var result = modalRef.content;
      if (result.userAction == "Cancel This Application") {
        this.hiringService.deleteOnboardByID().then((response: any) => {
          if (response != null && response.success) {
            window.location.href = "/Careers/BrowseJobs"; // this needs to be a page refresh, don't use angular routing here
          }
        })
      }
    });
  }

  submitTaskCheck() {
    if (this.savedFiles.length < 1 && this.maxAttachments != 0)
      this.showAttachmentWarning = true;
    else {
      this.showAttachmentWarning = false;
      this.submitTask();
    }
  }

  cancelSubmit() {
    this.showAttachmentWarning = false;
  }

  submitTask() {
    this.showAttachmentWarning = false;
    this.hiringService.submitOnboardTasks().then((response: any) => {
      if (response != null) {
        let modalRef = this.modalService.open(OnboardSubmittedModalComponent, { size: 'md', backdrop: 'static' });
        modalRef.componentInstance.status = response.success;
        modalRef.componentInstance.info = this.infoData;
        modalRef.componentInstance.reqID = this.reqID;
        modalRef.componentInstance.loginStatus = this.loginStatus;
      }
    });
  }

  updatepersonalInfo() {
    let modalRef = this.modalService.open(EditPersonalModalComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.info = this.infoData;
    modalRef.componentInstance.isOnboarding = this.infoData.IsOnboarding;
    modalRef.result.then((result: any) => {
      this.getInfo();
    }).catch((res) => { });
  }

  quitViewPDF() {
    this.viewPDF = false;
  }

  downloadRDL() {
    setTimeout(() => {
      var pdfviewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
      pdfviewer.unload();
    });
    this.utilityService.openModal();
    this.viewPDF = true;

    this.hiringService.downloadTaskRDL(null, null, true, true).then((response: any) => {
      var pdfviewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
      setTimeout(() => {
        pdfviewer.toolbar.showToolbarItem(new Array("SubmitForm"), false);
        pdfviewer.toolbar.showToolbarItem(new Array("OpenOption"), false);
        pdfviewer.toolbar.showToolbarItem(new Array("PrintOption"), true);
        pdfviewer.toolbar.showToolbarItem(new Array("AnnotationEditTool"), false);
        pdfviewer.toolbar.showToolbarItem(new Array("FormDesignerEditTool"), false);
        if (!this.mobileMode) {
          pdfviewer.toolbar.showToolbarItem(new Array("CommentTool"), false);
          pdfviewer.toolbar.showToolbarItem(new Array("UndoRedoTool"), false);
        }

        pdfviewer.documentPath = "data:application/pdf;base64," + (response);
        pdfviewer.downloadFileName = this.infoData.FirstName + this.infoData.LastName + "-" + this.jobDetails.PositionTitle + "-" + this.jobDetails.ReqNum + ".pdf";
      }, 2000);
    });
  }

  getAttachmentList() {
    this.newFiles = [];
    var requestParam = "moduleID=" + 60 + "&recordID=" + -1 + "&onboarding=" + true;
    this.employeeService.getFileAttachmentList(requestParam).then((response: any[]) => {
      if (response != null) {
        this.savedFiles = response;
      }
    });
  }

  deleteAttachment(data: any) {
    this.employeeService.removeFileAttachment(data.FileAttachmentID).then((response: any) => {
      if (response != null) {
        this.getAttachmentList();
      }
    }).catch((error: any) => {
      this.errorMsg = error?.error?.error ?? "An error has occured";
    });
  }

  readFile(file: any, call: any) {
    var reader = new FileReader();
    reader.onload = function (e) { return call(e, file.name) };
    reader.readAsDataURL(file);
  }

  upload() {
    this.newFiles = [];
    this.fileData = [];
    this.formData.fileDrop = this.formData.fileDrop.slice(0, (this.maxAttachments - this.savedFiles.length))
    var currentUpload = this.formData.fileDrop;
    this.formData.fileDrop = [];
    for (var i = 0; i < currentUpload.length; i++) {
      currentUpload[i].nameEdit = this.utilityService.formatAttachmentName(currentUpload[i].name);
    }
    for (var i = 0; i < currentUpload.length; i++) {
      var n = 0;
      this.innerCounter = 0;
      this.readFile(currentUpload[i], (e: any, fileName: string) => {
        setTimeout(() => {
          this.fileData.push({ data: e.target.result.toString().split(","), size: e.total, name: fileName });
          if (n == (currentUpload.length - 1)) {
            this.fileData.forEach((val: any) => {
              currentUpload.forEach((val2: any) => {
                if (val2.size == val.size && val.name == val2.name) {
                  this.newFiles.push({ File: val.data[1], Filename: val2.nameEdit, Filedata: val2, Type: val.data[0].split("/")[0] });
                }
              });
            });
            if (currentUpload && currentUpload.length >= 1) {
              this.newFiles.forEach((val3: any) => {
                if (val3.Progress != 100 && val3.File != null) {
                  var temp = val3.Type;
                  var type = "file";
                  if (temp == "data:image")
                    type = "Photo";
                  val3.Filedata.upload = new HttpRequest(
                    'POST',
                    "/Employee/SaveFileAttachment",
                    {
                      moduleID: 60, attachmentFileData: val3.File, attachmentFileName: val3.Filename, recordID: -1, attachmentType: type, onboarding: true
                    }, { reportProgress: true }
                  ),
                    val3.Filedata.upload = this.HttpClient.request(val3.Filedata.upload).subscribe((event: HttpEvent<any>) => {
                      switch (event.type) {
                        case HttpEventType.UploadProgress:
                          val3.Progress = Math.round(event.loaded / event.total * 100);
                          if (val3.Progress == 100) {
                            val3.AttchDone = true;
                          }
                          break;
                        case HttpEventType.Response:
                          this.innerCounter++;
                          this.watchInnerCounter();
                          val3.Filedata.result = event.body;
                      }
                    },
                      error => this.errorMsg = error.message);
                }
              });
            }
          }
          n++;
        });
      });
    }
  }

  watchInnerCounter() {
    if (this.innerCounter == this.newFiles.length && this.innerCounter != 0) {
      this.formData.fileDrop = null;
      this.getAttachmentList();
    }
  }

  fadeLabel(status: any) {
    this.formData.labelFade = false;
    this.lastSave = this.utilityService.fadeLabel(status);
    setTimeout(() => {
      this.formData.labelFade = true;
    }, 2000);
  }

}